
  import React from "react"
  import Component from "/opt/atlassian/pipelines/agent/build/src/layouts/index.js"
  import data from "/opt/atlassian/pipelines/agent/build/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js